import { Stack, Typography } from '@mui/material';
import MuiPhoneNumber from 'mui-phone-number';
import { FormattedMessage } from 'react-intl';

import QuickStartErrorText from '../common/errorText';
interface PrimaryContactTextFieldProps {
  value: string;
  setValue: (value: string) => void;
  error: string;
}

const PrimaryContactTextField = ({
  value,
  setValue,
  error,
}: PrimaryContactTextFieldProps) => {
  return (
    <Stack flexGrow={1} gap={0.5}>
      <Typography
        sx={{
          fontFamily: 'Schibsted Grotesk, sans-serif',
          fontSize: '16px',
          fontWeight: 500,
          color: '#181818',
          lineHeight: '125%',
          marginBottom: '12px',
        }}
      >
        <FormattedMessage defaultMessage='Primary Contact' />
      </Typography>
      <MuiPhoneNumber
        defaultCountry={'us'}
        InputProps={{ disableUnderline: true }}
        disableAreaCodes={true}
        sx={{
          border: '1px solid #D1D1D1',
          borderRadius: '6px',
          padding: '10px 16px',
          '& .MuiInputBase-input': {
            fontFamily: 'Schibsted Grotesk, sans-serif',
            fontSize: '16px',
            fontWeight: 500,
            color: '#181818',
            lineHeight: '125%',
          },
          '&:focus-within': {
            border: '1px solid #000000',
          },
        }}
        value={value}
        onChange={(e) => {
          setValue(typeof e === 'string' ? e : '');
        }}
      />
      {error !== '' && <QuickStartErrorText error={error} />}
    </Stack>
  );
};

export default PrimaryContactTextField;
